import $ from "jquery";

export default class CareInstructionsForm {
    constructor() {
        this.form = document.getElementById('care-instructions-form');
        this.successMessage = document.getElementById('email-success');
        
        if (this.form) {
            this.initEventListeners();
        }
    }
    
    initEventListeners() {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
    
    handleSubmit(e) {
        e.preventDefault();
        
        const emailInput = this.form.querySelector('input[name="email"]');
        const email = emailInput.value.trim();
        
        // Validate email before submitting
        if (!this.isValidEmail(email)) {
            this.showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            emailInput.focus();
            return;
        }
        
        const formData = new FormData(this.form);
        
        // Get the CSRF token from the hidden input field
        const token = document.querySelector('input[name="_token"]').value;
        
        fetch('/care-instructions-email', {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': token
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => this.handleResponse(data))
        .catch(error => this.handleError(error));
    }
    
    handleResponse(data) {
        if (data.success) {
            this.form.reset();
            this.successMessage.classList.remove('hidden');
            
            setTimeout(() => {
                this.successMessage.classList.add('hidden');
            }, 5000);
        } else {
            this.showError('Es gab einen Fehler beim Versenden der E-Mail. Bitte versuchen Sie es später erneut.');
        }
    }
    
    handleError(error) {
        console.error('Error:', error);
        this.showError('Es gab einen Fehler beim Versenden der E-Mail. Bitte versuchen Sie es später erneut.');
    }
    
    showError(message) {
        alert(message);
    }
    
    isValidEmail(email) {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return emailRegex.test(email);
    }
}
